import { render } from "./OverlayRoomSetup.vue?vue&type=template&id=cde0ff66"
import script from "./OverlayRoomSetup.vue?vue&type=script&lang=js"
export * from "./OverlayRoomSetup.vue?vue&type=script&lang=js"

import exportComponent from "/home/tachyon/wardrobe-test2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__